export const state = () => ({
  device: {}
});

export const mutations = {
  setDevice: function (state, device) {
    state.device = device;
  },
};
